import * as React from 'react'
import type { FormItemStatusContextProps } from '../interface'

export const FormItemInputContext = React.createContext<FormItemStatusContextProps>({})
